import {
  borderStyleTokens,
  borderWidthTokens,
  colorTokens,
  radiusTokens,
  shadowTokens,
  sizeTokens,
  spacingTokens,
  typographyTokens,
} from '../design-tokens'

export {
  borderStyleTokens,
  borderWidthTokens,
  colorTokens,
  effectTokens,
  radiusTokens,
  shadowTokens,
  spacingTokens,
} from '../design-tokens'

export const colorTokenMap = new Map(colorTokens.map((token) => [token.path, token.value]))
export const spacingTokenMap = new Map(spacingTokens.map((token) => [token.path, token.value]))
export const shadowTokenMap = new Map(shadowTokens.map((token) => [token.path, token.value]))
export const radiusTokenMap = new Map(radiusTokens.map((token) => [token.path, token.value]))
export const borderWidthTokenMap = new Map(
  borderWidthTokens.map((token) => [token.path, token.value])
)
export const borderStyleTokenMap = new Map(
  borderStyleTokens.map((token) => [token.path, token.value])
)
export const typographyTokenMap = new Map(typographyTokens.map((token) => [token.path, token]))
export const sizeTokenMap = new Map(sizeTokens.map((token) => [token.path, token.value]))
